var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRandomizeIcon = function SvgRandomizeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.312 6.11a.5.5 0 1 0-.624.78l1.396 1.118-2.267.012a4.5 4.5 0 0 0-3.663 1.92l-.83 1.188-.845-1.207A4.5 4.5 0 0 0 6.792 8H4.5a.5.5 0 0 0 0 1h2.292a3.5 3.5 0 0 1 2.867 1.494L10.714 12 9.66 13.506A3.5 3.5 0 0 1 6.791 15H4.5a.5.5 0 0 0 0 1h2.292a4.5 4.5 0 0 0 3.687-1.92l.844-1.208.83 1.188a4.5 4.5 0 0 0 3.664 1.92l2.267.012-1.396 1.118a.5.5 0 1 0 .624.78l2.5-2a.5.5 0 0 0 0-.78l-2.5-2a.5.5 0 1 0-.624.78l1.377 1.102-2.243-.012a3.5 3.5 0 0 1-2.849-1.494L11.933 12l1.04-1.486a3.5 3.5 0 0 1 2.85-1.494l2.242-.012-1.377 1.102a.5.5 0 1 0 .624.78l2.5-2a.5.5 0 0 0 0-.78z",
    clipRule: "evenodd"
  })));
};
export default SvgRandomizeIcon;